type GtagCommand = 'js' | 'config' | 'consent' | 'event';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (command: GtagCommand | string, ...args: unknown[]) => void;
  }
}

let isInitialized = false;

function ensureGtag() {
  window.dataLayer = window.dataLayer ?? [];
  window.gtag =
    window.gtag ??
    function gtag(...args: unknown[]) {
      window.dataLayer?.push(args);
    };
}

function hasGoogleAnalyticsScript(measurementId: string) {
  return Boolean(
    document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${measurementId}"]`),
  );
}

export function initGoogleAnalytics(measurementId: string) {
  if (!measurementId) return;

  ensureGtag();

  if (hasGoogleAnalyticsScript(measurementId)) {
    isInitialized = true;
    return;
  }

  if (isInitialized) return;

  window.gtag?.('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
  window.gtag?.('js', new Date());
  window.gtag?.('config', measurementId, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  isInitialized = true;
}

export function setGoogleAnalyticsConsent(granted: boolean) {
  ensureGtag();

  window.gtag?.('consent', 'update', {
    analytics_storage: granted ? 'granted' : 'denied',
    ad_storage: granted ? 'granted' : 'denied',
    ad_user_data: granted ? 'granted' : 'denied',
    ad_personalization: granted ? 'granted' : 'denied',
  });
}

export function trackGoogleAnalyticsPageView(measurementId: string, pagePath: string) {
  if (!measurementId || !window.gtag) return;

  window.gtag('config', measurementId, {
    page_path: pagePath,
  });
}
